import React, { useState, useEffect } from 'react';
import { listActiveModules, InstalledModuleRecord } from '../modules/ModuleRegistry.js';
import { RemoteModule } from '../modules/ModuleLoader.js';

export const AppLauncher: React.FC = () => {
  const [modules, setModules] = useState<InstalledModuleRecord[]>([]);
  const [activeModuleId, setActiveModuleId] = useState<string | null>(null);

  useEffect(() => {
    setModules(listActiveModules());
  }, []);

  if (activeModuleId) {
    return (
      <div className="flex flex-col h-full w-full">
        <button
          onClick={() => setActiveModuleId(null)}
          className="mb-4 px-3 py-1.5 bg-slate-800 text-slate-200 rounded self-start hover:bg-slate-700 transition"
        >
          &larr; Back to Grid
        </button>
        <div className="flex-1 overflow-hidden border border-slate-800 rounded-lg bg-slate-900/50 relative">
          <RemoteModule moduleId={activeModuleId} fallback={<div className="p-8 text-slate-400">Loading {activeModuleId}...</div>} />
        </div>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6 p-6">
      {modules.map((mod) => (
        <div
          key={mod.id}
          onClick={() => setActiveModuleId(mod.id)}
          className="bg-slate-900 border border-slate-800 rounded-xl p-5 hover:border-indigo-500/50 hover:bg-slate-800/80 cursor-pointer transition-all shadow-sm hover:shadow-md group flex flex-col gap-3"
        >
          <div className="h-12 w-12 rounded-lg bg-slate-800 flex items-center justify-center text-xl shadow-inner border border-slate-700 group-hover:bg-indigo-900/40 group-hover:border-indigo-500/30 transition-colors">
            {mod.category === 'social' ? '💬' : mod.category === 'utility' ? '🔧' : mod.category === 'media' ? '🖼️' : mod.category === 'iot' ? '🔌' : '📦'}
          </div>
          <div>
            <h3 className="text-slate-100 font-semibold text-base mb-1 group-hover:text-indigo-300 transition-colors">{mod.name}</h3>
            <p className="text-slate-400 text-xs font-mono">{mod.id}</p>
          </div>
          <div className="flex items-center gap-2 mt-auto pt-3 border-t border-slate-800/60">
            <span className="px-2 py-0.5 rounded text-[10px] font-bold uppercase tracking-wider bg-slate-800 text-slate-300">
              {mod.tier || 'public'}
            </span>
            <span className="px-2 py-0.5 rounded text-[10px] font-bold uppercase tracking-wider bg-slate-800 text-slate-300">
              v{mod.version}
            </span>
          </div>
        </div>
      ))}
      {modules.length === 0 && (
        <div className="col-span-full text-center p-12 border border-slate-800 border-dashed rounded-xl text-slate-500 bg-slate-900/20">
          No modules found. Ensure catalog is running.
        </div>
      )}
    </div>
  );
};
